import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import WidgetButton from '../../WidgetButton';

const useStyles = makeStyles({
  icon: {
    fontSize: 'medium'
  },
  tooltip: {
    fontSize: '13px',
    padding: '10px',
    maxWidth: '420px'
  }
});

const MenuButton = ({ description }) => {
  const classes = useStyles();

  return (
    <WidgetButton>
      <Tooltip
        title={description || 'There is no available description for this widget.'}
        classes={{ tooltip: classes.tooltip }}
        placement="top"
        arrow
      >
        <HelpOutlineOutlinedIcon className={classes.icon} />
      </Tooltip>
    </WidgetButton>
  );
};

MenuButton.propTypes = {
  description: PropTypes.string
};

MenuButton.defaultProps = {
  description: ''
};

export default MenuButton;
